<!--
 * @Author: zhaoyang
 * @Date: 2020-10-27 11:17:57
 * @LastEditors: zheng zheng@sence.sg
 * @LastEditTime: 2022-12-07 18:54:17
 * @Description: c端申请退款
-->
<template>
  <div>
    <div v-if="dialogloading" class="loading-line">
      <p>
        <i class="el-icon-loading" />
      </p>
    </div>
    <div v-else class="refound-page" ref="refRefound">
      <div class="refound-item">
        <div class="item-label">退款类型</div>
        <GCheckGroup
          class="refound-type-group"
          v-model="refoundType"
          :options="
            canRefoundCount !== 1
              ? [
                  { value: 'all', label: '全部退款' },
                  { value: 'part', label: '部分退款' }
                ]
              : [{ value: 'all', label: '全部退款' }]
          "
          @change="changRefoundType"
        >
          <template v-slot="{ item, checked }">
            <el-radio
              :class="[
                'select-type',
                item.value === 'part' && 'part-type',
                checked && 'fps-icon fps-icon-check'
              ]"
              :label="item.value"
              :value="refoundType"
              >{{ item.label }}</el-radio
            >
          </template>
        </GCheckGroup>
        <p v-show="refoundType == 'part'" style="color:red;font-weight:bold">部分退款後，剩餘訂單不可再發起退款</p>
      </div>
      <div
        v-show="refoundType !== 'all' && canRefoundCount !== 1"
        class="refound-item"
      >
        <div class="item-label">退款單數</div>
        <GInputNumber
          class="refound-count"
          v-if="canRefoundCount"
          v-model="refoundCount"
          :max="canRefoundCount"
        ></GInputNumber>
        <span class="no-count" v-else>暫無可退訂單</span>
      </div>
      <div class="refound-item">
        <div class="item-label">退款金額</div>
        <div class="refound-amount">{{ refoundAmount }}</div>
      </div>
      <div class="refound-item">
        <div class="item-label mg-b-24">
          退款詳情說明<span class="input-tip">(必填)</span>
        </div>
        <FpsTextArea
          class="reason-text"
          v-model="reasonDetail"
          placeholder="請輸入退款理由"
          @focus="handleExtra"
          @blur="isFixed = 'fixed'"
        ></FpsTextArea>
      </div>
      <div class="refound-item">
        <div class="item-label mg-b-24">
          上傳憑證<span class="input-tip">(非必填)</span>
        </div>
        <UploadImg class="reason-imgs" v-model="images" :max="5"></UploadImg>
      </div>
      <div class="refound-footer" v-if="orderInfo && canRefoundCount">
        <div
          class="refound-submit"
          :class="{ 'allow-submit': allowSubmit }"
          @click="refoundOrder"
        >
          提交退款申請
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GInputNumber from '@/components/common/input/input-number';
import GCheckGroup from '@/components/common/checkbox/general-checkbox';
import UploadImg from '@/components/common/upload/upload-image';
import FpsTextArea from '@/components/common/input/text-area';
export default {
  props: {
    dialogloading: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      refoundType: '',
      reasonDetail: '',
      refoundCount: 1,
      popupOpen: false,
      images: [],
      isFixed: 'fixed', // 用於處理部分機型按鈕擋住輸入框的情況
      showExplain: false
    };
  },
  computed: {
    refoundAmount() {
      if (!this.orderInfo || !this.canRefoundCount) return 0;
      const payAmount = this.orderInfo.currentAmount;
      const payCount = this.orderInfo.orderItemVoList[0].count;
      const result = (this.refoundCount / payCount) * payAmount;
      const intResult = parseInt(result);
      const floatResult = (Math.round(result * 100) / 100).toFixed(2);
      return result > intResult ? floatResult : intResult;
    },
    hasRefound() {
      if (!this.orderInfo) return 0;
      return (
        this.$util.getVal(
          this.orderInfo,
          'tradeRefundInfo.tradeRefundDetailList.0.refundNum'
        ) || 0
      );
    },
    canRefoundCount() {
      if (!this.orderInfo) return 1;
      return this.orderInfo.orderItemVoList[0].count - this.hasRefound;
    },
    allowSubmit() {
      return (
        ['reasonDetail'].every(key => {
          return this.$util.getVal(this, key);
        }) && this.refoundType
      );
    }
  },
  methods: {
    changRefoundType() {
      this.refoundCount = this.refoundType === 'all' ? this.canRefoundCount : 1;
    },
    checkNull() {
      return [
        { key: 'reasonDetail', msg: '請填寫退款說明' },
        { key: 'refoundType', msg: '請選擇退款類型' }
      ].some(item => {
        const { key, msg } = item;
        if (!this.$util.getVal(this, key)) {
          this.$toast(msg);
          return true;
        }
      });
    },
    refoundOrder() {
      if (this.checkNull() || this.refounding) return;
      this.refounding = true;
      this.$http
        .post('/tradeRefund/normalUserApplyRefund', {
          applyUuid: this.userInfo.uuid,
          desc: this.reasonDetail,
          images: this.images,
          orderNo: this.orderInfo.orderNo,
          refundApplyKind: 'C_REFUND',
          refundItemList: [
            {
              refundNum: this.refoundCount,
              salesUnit: this.orderInfo.orderItemVoList[0].salesUnit,
              skillId: this.orderInfo.orderItemVoList[0].playerSkillId
            }
          ],
          region: this.userInfo.region
        })
        .then(() => {
          this.refounding = false;
          this.$emit('handleRoundExplain', 'orderRoundDetail');
        })
        .catch(() => {
          this.refounding = false;
          this.$message.error('網絡忙');
        });
    },
    handleExtra() {
      this.isFixed = '';
      setTimeout(() => {
        this.$refs.refRefound.scrollTo(0, 0);
      }, 300);
    }
  },

  components: {
    GInputNumber,
    UploadImg,
    FpsTextArea,
    GCheckGroup
  }
};
</script>
<style lang="scss" scoped>
.loading-line {
  height: 40px;
  margin: 30px auto 0;

  p {
    @include flex();
    height: 40px;
  }

  i {
    font-size: 1.6em;
  }
}
.refound-page {
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-y: auto;
  height: auto;
  padding-bottom: 60px;
  /deep/ .btn-back {
    font-size: 15px !important;
    line-height: 21px !important;
    color: #666666;
  }
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}
.refound-title {
  border-bottom: 1px solid #dddddd;
}
.refound-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 18px 30px;
  font-size: 15px;
  color: #333333;
  line-height: 21px;
  > p {
    margin-top: 15px;
    font-size: 12px;
    line-height: 17px;
    text-align: right;
    width: 100%;
    color: #8c94aa;
  }
}
.refound-type-babel {
  margin: 0 23px 0 9px;
  font-size: 14px;
  font-weight: 400;
}
.refound-type-group /deep/ .check-item:not(:first-child) {
  margin-left: 20px;
}
.select-type {
  @include flex;
  &.fps-icon-check {
    font-size: 18px;
    &::before {
      display: inline-block;
      border-radius: 50%;
      background: $color-yellow;
    }
  }
  & /deep/ .el-radio__input {
    font-size: 0;
    .el-radio__inner {
      width: 18px;
      height: 18px;
      border: 1px solid #c8c9cc;
    }
    &.is-checked {
      .el-radio__inner {
        display: none;
      }
    }
  }
  & /deep/ .el-radio__label {
    padding-left: 0;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    color: #323233;
    margin-left: 9px;
  }
}
.refound-count {
  /deep/ .minus::before,
  /deep/ .plus::before {
    background: #f2f2f2;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    border-radius: 4px;
  }
  /deep/ .input-block {
    background: none;
  }
}
.item-label {
  font-weight: 500;
}
.refound-amount {
  font-size: 15px;
  color: #fe7f38;
}
.refound-explain {
  margin-left: 5px;
  vertical-align: bottom;
  font-size: 22px;
  color: #8c94aa;
}
.reason-text {
  width: 100%;
}
.reason-imgs {
  width: 100%;
}
.mg-b-24 {
  margin-bottom: 12px;
}
.input-tip {
  font-weight: 400;
  color: #8c94aa;
}
.refound-footer {
  width: 375px;
  bottom: 0;
  left: 0;
  padding: 0 16px 30px;
  position: absolute;
}
.refound-submit {
  width: 100%;
  height: 48px;
  text-align: center;
  line-height: 48px;
  font-weight: 500;
  font-size: 16px;
  color: rgba(99, 109, 134, 0.3);
  background: #f1f4f6;
  border-radius: 25px;
  cursor: pointer;
}
.no-count {
  font-weight: 400;
  color: #8c94aa;
}
.allow-submit {
  @include button-yellow;
  font-weight: 400;
}
</style>
<style lang="scss">
.corder-round.el-dialog {
  position: relative;
  border-radius: 8px;
  .el-dialog__body {
    padding: 21px 0 30px !important;
  }
  .el-dialog__header {
    padding: 18px;
    border-bottom: 1px solid #ececec;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
    .el-dialog__headerbtn {
      font-size: 20px;
      .el-dialog__close {
        font-weight: 800;
      }
    }
  }
  .corder-round-title {
    display: flex;
    align-items: center;
    > span {
      font-weight: 500;
      font-size: 18px;
      margin-right: 7px;
    }
    > i {
      cursor: pointer;
    }
  }
}
</style>
